<template>
    <div class="constructor_scroll">
        <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
            <div class="tittle">
                <div class="breadcrumbs">
                    <h1>{{textContent.titleMain}}</h1>
                </div>
                <div class="drop_search">
                    <!--<table-filter class="filter" :url="apiUrls.articleCategories" name="category" title="title"></table-filter>-->
                    <!--<table-filter class="filter" :url="apiUrls.authors" name="author" title="name"></table-filter>-->
                    <!--<search></search>-->
                </div>
            </div>
            <div class="subtitle with-pagination">
                <div class="modal_button">
                    <router-link tag="button" to="/library/recommended-films/create"><icon-add/>{{textContent.addItemText}}</router-link>
                </div>
                <div class="amount_pagination">
                    <quantity></quantity>
                    <pagination></pagination>
                </div>
            </div>
            <p class="no-message" v-if="emptyData">{{textContent.notFoundText}}</p>
            <main-table v-else></main-table>
            <pagination :is-bottom="true" v-if="!emptyData"></pagination>
            <create-modal v-if="isAdd"></create-modal>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Search from '@/components/Search'
import Quantity from '@/components/filters/Quantity'
import TableFilter from '@/components/filters/Name'
import Period from '@/components/filters/Period'
import CreateModal from '../CreateModal'
import MainTable from '../MainTable'
import CalendarFilters from '@/components/filters/CalendarFilters'
import { createNamespacedHelpers } from 'vuex'
import IconAdd from '@/components/icons/IconAdd'

const { mapMutations, mapGetters, mapActions, mapState } = createNamespacedHelpers('mainPage')

export default {
  computed: {
    ...mapState([
      'textContent',
      'currentNumber',
      'filterItems',
      'isAdd',
      'emptyData',
      'itemsPerPage'
    ]),
    apiUrls () {
      return this.$store.state.apiUrls
    }
  },
  methods: {
    ...mapMutations([
      'setTextContent',
      'setCurrentParentId',
      'resetModule',
      'setPaginationParams',
      'setSortingParams',
      'setCurrentPage',
      'setGetParams',
      'setUrl'
    ]),
    ...mapActions([
      'getItems',
      'onAddItem',
      'getQuantityItems'
    ])
  },
  created () {
    this.resetModule();
    this.setCurrentParentId(this.$store.state.parentId.library.recommendedFilms);
    this.setUrl(this.apiUrls.content)
    this.setTextContent({
      titleMain: 'Рекомендуемые фильмы',
      addItemText: 'Добавить',
      notFoundText: 'Фильмов не найдено',
      addGreeting: 'Фильм успешно создан',
      deleteGreeting: 'Фильм успешно удален',
      titleAdd: 'Добавить',
      cancelButton: 'Отмена',
      submitButton: 'Добавить'
    });
    this.getQuantityItems()
      .then(() => {
        let offset = (this.$route.query.page) ? (this.$route.query.page - 1) * this.itemsPerPage : 0;
        this.setCurrentPage((this.$route.query.page) ? +this.$route.query.page : 1)
        this.setPaginationParams([
          {name: 'limit', value: this.itemsPerPage},
          {name: 'offset', value: offset}
        ])
        this.setSortingParams([
          {name: 'sortedBy', value: 'desc'},
          {name: 'orderBy', value: 'ord'},
        ])
        this.setGetParams([
          {name: 'searchFields', value: 'parent_id'},
          {name: 'search', value: this.$store.state.parentId.library.recommendedFilms},
          {name: 'filter', value: 'title;author_id;seo_img;url;subtext;is_active;id;ord'}
        ])
        this.getItems()
      })
  },
  components: {
    Pagination,
    Search,
    MainTable,
    Quantity,
    CreateModal,
    TableFilter,
    Period,
    CalendarFilters,
    IconAdd
  }
}
</script>

<style lang="scss" scoped>
    $grey-3: #999a9d;

    .constructor-scroll .no-message {
        color: $grey-3;
    }

    .constructor_scroll .container-block .tittle {
        @media screen and (max-width: 550px) {
            flex-direction: column !important;
        }

        h1 {
            @media screen and (max-width: 550px) {
                align-self: flex-start;
            }
        }
    }

    #app .tittle .drop_search {
        @media screen and (max-width: 550px) {
            margin-top: 12px;
            width: 100%;
        }

        .filter {
            @media screen and (max-width: 550px) {
                width: 100%;
            }
        }
    }

    .constructor_scroll .container-block .subtitle button {
        @media screen and (max-width: 619px) {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/library/recommended-films/pages/Index.vue